import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetAllVerificacaoChecklistListaUseCase } from "../../../presentation/useCases/read/get_all_verificacao_checklist_lista_use_case";
import { VerificacaoChecklistModel } from "../../models/verificacao_checklist";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * GetAllVerificacaoChecklistListaUseCase
 */

export class GetAllVerificacaoChecklistListaUseCase
  extends BasePaginatedUseCase<VerificacaoChecklistModel>
  implements IGetAllVerificacaoChecklistListaUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) {
    super();
  }

  async execute(idEntregaObraCliente: number): Promise<void> {
    const result = await this.repository.getAllVerificacaoChecklist(idEntregaObraCliente);

    this._items = result.items;
    this._currentPage = result.currentPage;
    this._pageSize = result.pageSize;
    this._totalItems = result.totalItems;
    this._totalPages = result.totalPages;
  }
}
